import React, { useEffect, useState } from 'react';
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';

const ProducteursArticles = ({ uNum, user }) => {
    const [articles, setArticles] = useState([]);
    const [articlesCdes, setArticlesCdes] = useState([]); // Initialisé par défaut en tableau
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/articles/${uNum}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setArticles(data);
                } else {
                    setArticles([]);
                }
            });
    }, [uNum]);

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/cdesarticles/${user}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(data => {
                // SÉCURITÉ : On vérifie si l'API renvoie bien un tableau
                if (Array.isArray(data)) {
                    setArticlesCdes(data);
                } else {
                    // Si l'API renvoie un objet ou null, on force un tableau vide pour éviter le crash du .find
                    setArticlesCdes([]);
                }
            })
            .catch(err => {
                console.error("Erreur fetch cdesarticles:", err);
                setArticlesCdes([]);
            });
    }, [user]);

    return (
        <p>
            {articles
                .filter(article => article && article.aStockIni >= 0)
                .sort((a, b) => a.aLibelle.localeCompare(b.aLibelle))
                .map((article, index) => {
                    const commandesValides = Array.isArray(articlesCdes) ? articlesCdes : [];

                    const commandeAssociee = commandesValides.find(
                        cde => cde && String(cde.cArticle) === String(article.aNum)
                    );

                    const isInPanier = commandeAssociee && commandeAssociee.Nb > 0;

                    let baseClass = article.aStockIni > 0 ? 'article-list-cdes' : 'article-list';

                    if (isInPanier) {
                        baseClass += ' article-list-panier';
                    }

                    return (
                        <span className={baseClass} key={article.aNum || index}>
                            {/* 1. ON INJECTE LA BILLE AVEC LE NOMBRE DE COMMANDES ICI */}
                            {isInPanier && (
                                <span className="bille-panier">
                                    {commandeAssociee.Nb}
                                </span>
                            )}
                            {article.aLibelle}
                        </span>
                    );
                })}
        </p>
    );
};

export default ProducteursArticles;